import { DAIMI_INTRO, DAIMI_SLUG } from '@/content/daimi'
import { DAIMI, LABS_EYEBROW, cover, pdf } from '@/content/reportBuilder'
import type { Report } from '@/content/reportBuilder'

export const report: Report = {
  // The one report with a designed landing page of its own rather than the
  // shared template — see `content/daimi.ts` and `pages/Daimi.tsx`. Everything
  // in this entry is still used: the index card reads the cover and the title,
  // and the prerender pass takes `<title>` from the title and the meta
  // description from `body[0]`.
  slug: DAIMI_SLUG,
  title: DAIMI,
  eyebrow: LABS_EYEBROW,
  headline: DAIMI,
  cover: cover('daimi-report-2026-cover', DAIMI),
  // The page's own opening words, so the search result and the page agree.
  // They used to be a paraphrase written here, which was the honest thing to
  // do while nobody had supplied the report's own — that is what the amber note
  // said, and it is what `DAIMI_INTRO.check` says now instead.
  body: DAIMI_INTRO.body,
  // The bucket key folds the "&" of the title to "_" — the same ASCII fold
  // that turned "Türkiye" into "Turkiye" below. The file is the global 2026
  // edition; the USA one is a separate key ending "… 2026 USA.pdf".
  download: pdf('343e6687-e5ec-42a3-809a-878dc79b1e5c-Digitopia Digital _ AI Maturity Report 2026.pdf'),
  layout: 'daimi',
  // No `stillToCome` note: this report has its file, its cover and its own
  // words. What is still unresolved about it is section-by-section on its
  // landing page, and `daimiChecks()` is what carries it into the manifest.
  check: undefined,
}

/** Its place in the index grid — the order the imported page listed them. */
export const order = 0
